import { ApolloClient, gql } from '@apollo/client'
import { GraphQLContext } from '@moonpig/web-core-graphql'

type UserDataResponse = {
  id: string
  email: string
  intercom: {
    userDataJwt: string
  }
}

type UserDataQuery = {
  me: {
    customer: {
      id: string
      email: string
      intercom: {
        userDataJwt: string
      }
    }
  }
}

const userDataQuery = gql`
  query IntercomUserDataQuery {
    me {
      __typename
      customer {
        __typename
        id
        email
        intercom {
          __typename
          userDataJwt
        }
      }
    }
  }
`

export const queryUserData = async (
  query: ApolloClient<GraphQLContext>['query'],
): Promise<UserDataResponse> => {
  const result = await query<UserDataQuery>({
    query: userDataQuery,
    errorPolicy: 'all',
  })

  const { data, errors } = result

  if (errors && errors.length) {
    throw new Error(errors.map(error => error.toString()).join(', '))
  }

  const { customer } = data.me

  return {
    id: customer.id,
    email: customer.email,
    intercom: {
      userDataJwt: customer.intercom.userDataJwt,
    },
  }
}
